import React from 'react';

const PaymentResultPage = React.lazy(() => import('pages/PaymentResult'));

const paymentResultRoute = [
  {
    path: '/payment-result',
    exact: true,
    name: 'Ket qua thanh toan',
    component: PaymentResultPage,
  },
];

export default paymentResultRoute;
